export enum CsvErrorCategory {
  SORT = 'sort',
  FILTER = 'filter',
  LAYOUT = 'layout',
  FIELD = 'field',
  VIEW = 'view',
  VALUE = 'value',
  ENTRY = 'entry',
  METADATA = 'metadata',
  PARSING = 'parsing',
}

export interface CsvParsingError {
  message: string;
  category: CsvErrorCategory;
  timestamp: number;
  context?: string;
}

export class CsvErrorCollector {
  private errors: CsvParsingError[] = [];

  addError(message: string, category: CsvErrorCategory, context?: string): void {
    this.errors.push({
      message,
      category,
      timestamp: Date.now(),
      context,
    });
  }

  getErrors(): CsvParsingError[] {
    return [...this.errors];
  }

  clearErrors(): void {
    this.errors = [];
  }

  hasErrors(): boolean {
    return this.errors.length > 0;
  }

  getErrorCount(): number {
    return this.errors.length;
  }

  getErrorsByCategory(category: CsvErrorCategory): CsvParsingError[] {
    return this.errors.filter((error) => error.category === category);
  }
}
